import v4 from 'uuid'

export const createGoals = values => {
  const { verylow, low, high, veryhigh, disease, description, code } = values
  const goalLowPriority = {
    identifier: [
      {
        value: v4()
      }
    ],
    resourceType: 'Goal',
    status: 'proposed',
    category: [
      {
        coding: [
          {
            system: 'http://hl7.org/fhir/goal-category',
            code: 'safety'
          }
        ]
      }
    ],
    priority: {
      coding: [
        {
          system: 'http://hl7.org/fhir/goal-priority',
          code: 'low-priority',
          display: 'Low Priority'
        }
      ],
      text: 'low'
    },
    description: {
      text: 'seuil'
    },
    addresses: [
      {
        reference: disease
      }
    ],
    target: createTarget(low, high, disease, description, code)
  }
  const goalHighPriority = {
    identifier: [
      {
        value: v4()
      }
    ],
    resourceType: 'Goal',
    status: 'proposed',
    category: [
      {
        coding: [
          {
            system: 'http://hl7.org/fhir/goal-category',
            code: 'safety'
          }
        ]
      }
    ],
    priority: {
      coding: [
        {
          system: 'http://hl7.org/fhir/goal-priority',
          code: 'high-priority',
          display: 'High Priority'
        }
      ],
      text: 'high'
    },
    description: {
      text: 'seuil'
    },
    addresses: [
      {
        reference: disease
      }
    ],
    target: createTarget(verylow, veryhigh, disease, description, code)
  }
  return [goalHighPriority, goalLowPriority]
}

const createTarget = (low, high, disease, description, code) => {
  let unit
  let unitCode
  switch (description) {
    case 'heartRate':
      unit = 'pul/min'
      unitCode = '[pul/min]'
      break
    case 'bodyWeight':
      unit = 'kg'
      unitCode = '[kg]'
      break
    case 'fasting':
    case 'midday':
    case 'evening':
      unit = 'mg/dL'
      unitCode = '[mg/dL]'
      break
    case 'systolic':
    case 'diastolic':
      unit = 'mmHg'
      unitCode = '[mmHg]'
      break
    default:
      unit = ''
      unitCode = ''
      break
  }
  return {
    measure: {
      coding: [
        {
          system: 'http://loinc.org',
          code: code,
          display: description
        }
      ]
    },
    detailRange: {
      low: {
        value: low,
        unit: unit,
        system: 'http://unitsofmeasure.org',
        code: unitCode
      },
      high: {
        value: high,
        unit: unit,
        system: 'http://unitsofmeasure.org',
        code: unitCode
      }
    }
  }
}

export const editGoals = values => {
  const {
    verylow,
    low,
    high,
    veryhigh,
    oldGoals,
    disease,
    description,
    code
  } = values
  let { highPriority, lowPriority } = extractGoals(oldGoals)

  if (highPriority && lowPriority) {
    highPriority.target = createTarget(
      verylow,
      veryhigh,
      disease,
      description,
      code
    )
    lowPriority.target = createTarget(low, high, disease, description, code)
  }
  return [highPriority, lowPriority]
}

const extractGoals = oldGoals => {
  const lowPriority = oldGoals.filter(
    goal =>
      goal.priority &&
      goal.priority.coding &&
      goal.priority.coding.length > 0 &&
      goal.priority.coding[0].code === 'low-priority'
  )[0]

  const highPriority = oldGoals.filter(
    goal =>
      goal.priority &&
      goal.priority.coding &&
      goal.priority.coding.length > 0 &&
      goal.priority.coding[0].code === 'high-priority'
  )[0]

  return { highPriority, lowPriority }
}



// WEBPACK FOOTER //
// ./src/Goal/helpers.js